import Fingerprint from 'utilities/Fingerprint';

export default {
    isEmpty: function (value) {
        //NOTE: If sonarqube complains: we WANT type coercion here, because: null == undefined --> true
        return value == null || value.length === 0;
    },
    isEmptyOrWhitespace: function (value) {
        if (typeof value === 'string') {
            value = value.trim();
        }
        //NOTE: If sonarqube complains: we WANT type coercion here, because: null == undefined --> true
        return value == null || value.length === 0;
    },
    getValueOrDefault: function (item, fallback = '') {
        return item == null ? fallback : item;
    },
    aggregatedDebounce: function (func, wait) {
        var timeout;
        var allArgs = [];
        return function (...args) {
            allArgs.push(args);
            var context = this;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                timeout = null;
                func.apply(context, allArgs);
                allArgs = [];
            }, wait);
        };
    },
    getCoordinatesRelativeToDocument(elem) {
        const box = elem.getBoundingClientRect();
        const body = document.body;
        const docEl = document.documentElement;

        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        const clientTop = docEl.clientTop || body.clientTop || 0;
        const clientLeft = docEl.clientLeft || body.clientLeft || 0;

        const top = box.top + scrollTop - clientTop;
        const left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    },
    isEmptyObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) return false;
        }

        return true;
    },
    getOsVersion() {
        const { navigator } = window;
        const regex = /\((.*?)\)/;
        const { appVersion } = navigator;
        if (!new RegExp(regex).test(appVersion)) {
            return 'Unknown';
        }
        return appVersion.match(regex)[1] || navigator.appVersion.match(regex)[0] || 'Unknown';
    },
    initFingerprint() {
        let openbankFp = localStorage.getItem('openbank_fp');
        if (!openbankFp) {
            openbankFp = new Fingerprint().get();
            localStorage.setItem('openbank_fp', openbankFp);
        }
        return openbankFp;
    },

    isEqualOrHigherVersion(versionA, versionB) {
        const response = versionA.localeCompare(versionB, undefined, { numeric: true, sensitivity: 'base' });
        return response >= 0;
    },

    checkIfInputIsVisibleByPartialId(id) {
        const inputContainer = document.querySelector(`[id*='${id}']`);
        return inputContainer?.offsetParent;
    },
};
